import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

const SDrawer = styled.div<{ dark: boolean }>`
    transform: translate(0, 0);
    background-color: ${({ theme, dark }) => (dark ? theme.font.lightestColor : theme.font.darkestColor)};
    color: ${({ theme, dark }) => (dark ? theme.font.darkestColor : theme.font.lightestColor)};
    letter-spacing: 1%;

    position: fixed;
    z-index: 1040;
    top: 0;
    height: 100%;
    width: 240px;
    right: -240px;
    overflow-x: hidden;
    transition: right 0.25s ease-in-out;

    padding: 120px 30px;

    &.open {
        right: 0;
        transition: right 0.25s ease-in-out;
        overflow-y: hidden;
    }

    display: flex;
    flex-direction: column;
    gap: 18px;
`

export type DrawerProps = {
    children: React.ReactNode
    dark?: boolean
    className?: ClassName
    style?: React.CSSProperties
}

export const Drawer = React.memo(function Drawer({
    children,
    className,
    style,
    dark = false,
}: DrawerProps): React.ReactElement {
    return (
        <SDrawer className={cn(className)} style={style} dark={dark} data-testid="drawer">
            {children}
        </SDrawer>
    )
})
